import React from 'react';
import { Button } from 'react-bootstrap';

const ReminderPopup = ({ onContinue }) => (
  <div
    className="d-flex flex-column align-items-center justify-content-center position-fixed top-0 start-0 w-100 vh-100 text-white"
    style={{ zIndex: 9999, background: 'rgba(0,0,0,0.7)' }}
  >
    <h2 style={{ color: '#faad14' }}>Session Timeout Warning</h2>
    <p>Your session will timeout in 1 minute. Do you want to continue?</p>
    <Button variant="warning" onClick={onContinue}>
      Continue
    </Button>
  </div>
);

export default ReminderPopup;
